import {reject, isNil} from 'ramda';

import {CustomerAdvancedSearchResultResponseBody} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getAdvancedCustomerPhoneNumbers = (
  customer: CustomerAdvancedSearchResultResponseBody | Nullish
) => {
  const phoneNumbers =
    customer?.discriminator === 'BUSINESS'
      ? customer?.contacts.flatMap((contact) => contact.phone)
      : [customer?.foundingPerson?.phone];

  const uniquePhoneNumbers = new Set(reject(isNil, phoneNumbers ?? []));

  return Array.from(uniquePhoneNumbers).map((phone) => ({value: phone, label: phone}));
};
